import { render, staticRenderFns } from "./showDOD.vue?vue&type=template&id=6f4b96e2&scoped=true"
import script from "./showDOD.vue?vue&type=script&lang=js"
export * from "./showDOD.vue?vue&type=script&lang=js"
import style0 from "./showDOD.vue?vue&type=style&index=0&id=6f4b96e2&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4b96e2",
  null
  
)

export default component.exports